import { React, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  textarea,
  Tooltip,
  Table,
  Tabs,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, Styled, StyledTab } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import ParentJumboReelDrawer from "./JumboReelsDrawer/parentJumboReelDrawer";
import {
  getJumboReelDetails,
  deleteJumboReel,
  getMappedParentReels,
  changeJumboReelStatus,
  searchJumboReelsMappingDetails,
} from "../../../Services/productionPlanningServices";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import MultiStageParentSetDrawer from "../ProductionDetails/ProductionDetailsDrawers/viewCombinationDetailsDrawer";
import JumboReelParentSetDrawer from "./JumboReelsDrawer/viewParentSetDrawer";
function onChange(pagination, filters, sorter, extra) {
  // console.log("params", pagination, filters, sorter, extra);
}
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const Panes = Tabs.TabPane;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY/MM/DD";
const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
const { Option } = Select;
const productNameData = ["HW45434- Kraft Paper", "NK25754- wind Paper"];
const shiftData = ["1st", "2nd", "3rd"];
const machineData = ["PM1", "PM2", "PM3"];
const { TextArea } = Input;

const ViewJumboReel = (props) => {
  const [productName, setProductName] = useState(productNameData[0]);
  const [machine, setMachine] = useState(machineData[0]);
  const [shift, setshift] = useState(shiftData[0]);
  const [isVisibleJumboModal, setIsVisibleJumboModal] = useState(false);
  const [isVisibleDeleteJumboModal, setIsVisibleDeleteJumboModal] =
    useState(false);
  const [viewParentJumboReelDrawer, setviewParentJumboReelDrawer] =
    useState(false);
  const location = useLocation();
  const [id, setId] = useState(location.state.id);
  const [details, setDetails] = useState();
  const [mappedParentReelsList, setMappedParentReelsList] = useState([]);
  const [selectedJR, setSelectedJR] = useState(null);
  const [isProduced, setIsProduced] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [jobcardType, setJobcardType] = useState();
  const [closeJumboVisible, setCloseJumboVisible] = useState(false);
  const [exportRecords, setExportRecords] = useState([]);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [rerendering, setRerendering] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [measurementData, setMeasurementData] = useState();

  useEffect(() => {
    if (rerendering && searchValue == "") {
      getJumboReelDetails(id)
        .then((resp) => {
          // console.log("Details", resp);
          setDetails(resp.data.data);
          getMappedParentReels({
            parent_reels: resp.data.data.mapped_parent_reels,
          })
            .then((response) => {
              setEmptyStateLabel("noData");
              // console.log("Parent", response);
              const list = response.data.data.map((item) => {
                const jc_code = getJCCode(item.jobcard_code);
                const status = item.status === "mapped" ? "Mapped" : "Produced";
                const weight = item.weight? item.weight.toFixed(2) : "";
                const core_id = item.machine_type !== "cutter" ? item.core_id : "-";
                const reel_od = item.machine_type !== "cutter" ? item.reel_od : "-";
                const finishing_date = `${(item.rewinding_date? moment(item.rewinding_date).format("DD MMM YYYY") : "") + " " + 
                (item.cutting_date ? moment(item.cutting_date).format("DD MMM YYYY") : "")}`;
                return { ...item, status, weight, core_id, reel_od, finishing_date, jc_code };
              });
              setMappedParentReelsList(list);
            })
            .catch((error) =>{
              console.log("Error while fetching parent reel details", error)
              setEmptyStateLabel("connectionAPIError");
            });
        })
        .catch((err) =>{
          console.log("Error which fetching jumbo reel details", err)
          setEmptyStateLabel("connectionAPIError");
        });
      
      setRerendering(false);
    } else if (rerendering && searchValue !== "") {
      searchJumboReelsMappingDetails(id, searchValue)
        .then((response) => {
          setEmptyStateLabel("search");
          if (response.length > 0) {
            const list = response.parent_reels.map((item) => {
              const status = item.status === "mapped" ? "Mapped" : "Produced";
                const weight = item.weight? item.weight.toFixed(2) : "";
                const core_id = item.machine_type !== "cutter" ? item.core_id : "-";
                const reel_od = item.machine_type !== "cutter" ? item.reel_od : "-";
                const finishing_date = `${(item.rewinding_date? moment(item.rewinding_date).format("DD MMM YYYY") : "") + " " + 
                (item.cutting_date ? moment(item.cutting_date).format("DD MMM YYYY") : "")}`;
                return { ...item, status, weight, core_id, reel_od, finishing_date };
            });
            setMappedParentReelsList(list);
          }
          else
            setMappedParentReelsList([]);
        })
        .catch((error) => {
          setEmptyStateLabel("connectionAPIError");
          console.log("Error in search of order records:", error);
        });
      setRerendering(false);
    }
  }, [rerendering]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    getUnitData()
      .then((response) => {
        if(response && !response.error){
          setMeasurementData(response.data);
        }
      })
      .catch((error) => {
        console.log("Error in fetching advanced settings data:", error);
      });
  }, []);

  const columnsHead = [
    {
      title: "PARENT REEL/SET NO",
      dataIndex: "id",
      width: "13.6%",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id,
      },
      fixed: "left",
      align: "center",
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => showParentJumboReel(record)}
          >
            {`#${record.id}`}
          </Button>
        </div>
      ),
    },
    {
      title: "JOB CARD NO",
      dataIndex: "jc_code",
      width: "18%",
      // sorter: {
      //   compare: (a, b) => a.jobcard_no && b.jobcard_no && a.jobcard_no - b.jobcard_no ,
      // },
      fixed: "left",
      align: "center",
    },
    {
      title: "FINISHING DATE",
      dataIndex: "finishing_date",
      width: "11%",
    },
    {
      title: "SIZE",
      dataIndex: "size",
      width: "7%",
      render: (text, record) => `${text}${" "}${record.units? lengthUnit[record.units.size]?.displayName?.toUpperCase() : "CM"}`
    },
    {
      title: "CORE OD ",
      dataIndex: "core_id",
      width: "9.5%",
      align: "center",
      render: (text, record) => `${text}${" "} ${text !== "-" ? `${record.units? lengthUnit[record.units.core_id]?.displayName?.toUpperCase() : "CM"}` :  ""}`    },
    {
      title: "REEL OD ",
      dataIndex: "reel_od",
      width: "9%",
      align: "center",
      render: (text, record) => `${text}${" "} ${text !== "-" ? `${record.units? lengthUnit[record.units.reel_od]?.displayName?.toUpperCase() : "CM"}` :  ""}`    },
    {
      title: "WEIGHT",
      dataIndex: "weight",
      width: "11%",
      align: "center",
      render: (text, record) => `${text}${" "}${record.units? capitalize(weightUnit[record.units.weight]?.displayName) : "T"}`

    },
    {
      title: "NO OF REELS/SHEETS",
      dataIndex: "number_of_reels",
      width: "11%",
      align: "center",
    },
    {
      title: "TRIM",
      dataIndex: "trim_loss",
      width: "8%",
      align: "center",
      render: (text, record) => text?.toFixed(2) + " " + (record.units? lengthUnit[record?.units?.trim_loss]?.displayName?.toUpperCase() : "CM"),
    },
    {
      title: (
        <div>
          NET TRIM
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim including edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "net_trim_loss",
      width: "10.8%",
      align: "center",
      render: (text, record) => text?.toFixed(2) + " " + (record.units? lengthUnit[record?.units?.net_trim_loss]?.displayName?.toUpperCase() : "CM"),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      width: "10%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "produced"
                  ? "Production of this parent reel is complete"
                  : record.status === "mapped"
                  ? "This parent reel is mapped for rewinding"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "9%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this parent reel"}
              className="edit-tooltip"
            >
              <Button onClick={() => showParentJumboReel(record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  const handleShiftChange = (value) => {
    setshift(shiftData[value]);
  };
  const handleProductNameChange = (value) => {
    setProductName(productNameData[value]);
  };
  const handleMachineChange = (value) => {
    setMachine(machineData[value]);
  };
  const deleteJumboModalShow = () => {
    setIsVisibleDeleteJumboModal(true);
  };
  const deleteJumboModalClose = () => {
    setIsVisibleDeleteJumboModal(false);
  };
  const jumboModalShow = () => {
    setIsVisibleJumboModal(true);
  };
  const jumboModalClose = () => {
    setIsVisibleJumboModal(false);
  };
  const closeParentJumboReel = () => {
    setviewParentJumboReelDrawer(false);
    setIsProduced(false);
    setJobcardType();
  };
  const showParentJumboReel = (record) => {
    setSelectedJR(record.id);
    setviewParentJumboReelDrawer(true);
    setJobcardType(record.jobcard_type);
    setIsProduced(record.status === 'produced' || record.status === "rejected");
  };
  const history = useNavigate();

  const routeChange = () => {
    history("../jumbo-reel-records/edit-jumbo-reel", { state: { id: id } });
  };

  const handleTabChange = () => {
    setSearchValue("");
    setClearSearch(true);
  }

  const deleteReel = (number) => {
    deleteJumboReel(number)
      .then((resp) => {
        setIsVisibleDeleteJumboModal(false);
        setActionToaster({
          error: resp.error,
          msg: `Jumbo roll is successfully deleted.`,
        });
        setShowToaster(true);
      })
      .catch((err) => {
        setActionToaster({
          error: true,
          msg: `Error while deleting jumbo roll`,
        });
        setShowToaster(true);
      });
  };

  const showCloseModal = () => {
    setCloseJumboVisible(true);
  };

  const cancelCloseModal = () => {
    setCloseJumboVisible(false);
  };

  const confirmCloseModal = () => {
    changeJumboReelStatus({ number: id, status: "closed" })
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: response.msg,
        });
        setShowToaster(true);
      })
      .catch((error) => {
        setActionToaster({
          error: error.response.error,
          msg: error.response.msg,
        });
        setShowToaster(true);
      });
    setCloseJumboVisible(false);
  };

  useEffect(() => {
      if (exportRecords.length) {
      const currentDate = new Date();
      const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" +  currentDate.getFullYear());
      let fileName = "Jumbo_reel_mapping_records_Kaiznn_"+today;
      history("../jumbo-reel-records/export",{
        state:{ 
          rootPage: "../jumbo-reel-records",
          jumboRecords: exportRecords,
          pageKey: "Mapping Details",
          fileName: fileName,
        },
      });  
    }
  }, [exportRecords]);

  const exportHandler = () => {
    // console.log(mappedParentReelsList);
    let exportDataJson = {};
    let  formattedList = [];
    mappedParentReelsList?.map((item) => {
      exportDataJson = {};
      exportDataJson["parentReelNo"] = item.id;
      exportDataJson["jobCardNo"] = item.jobcard_no;
      exportDataJson["jc_code"] = item.jc_code;
      exportDataJson["jobCardState"] = item.jobcard_state;
      exportDataJson["rewinding_date"] = item.rewinding_date;
      exportDataJson["cutting_date"] = item.cutting_date;
      exportDataJson["size"] = item.size;
      exportDataJson["core_id"] = item.machine_type !== "cutter" ? item.core_id : "-";
      exportDataJson["reel_od"] = item.machine_type !== "cutter" ? item.reel_od : "-";
      exportDataJson["weight"] = item.weight;
      exportDataJson["noOfChildReels"] = item.number_of_reels;
      exportDataJson["matchTrim"] = item.trim_loss;
      exportDataJson["netTrim"] = item.net_trim_loss;
      exportDataJson["parentReelStatus"] = item.status;
      exportDataJson["units"] = item.units;
      formattedList.push(exportDataJson);
    });
    setExportRecords(formattedList);
  };

  const searchJumboRollMappingDetails = async (value = "") => {
    setSearchValue(value);
    if (value === "" || value === null) {
      setRerendering(true);
    } else {
      searchJumboReelsMappingDetails(id, value)
        .then((response) => {
          setEmptyStateLabel("search");
          if (response.parent_reels) {
            const list = response.parent_reels.map((item) => {
              const status = item.status === "mapped" ? "Mapped" : "Produced";
                const weight = item.weight? item.weight.toFixed(2) : "";
                const core_id = item.machine_type !== "cutter" ? item.core_id : "-";
                const reel_od = item.machine_type !== "cutter" ? item.reel_od : "-";
                const finishing_date = `${(item.rewinding_date? moment(item.rewinding_date).format("DD MMM YYYY") : "") + " " + 
                (item.cutting_date ? moment(item.cutting_date).format("DD MMM YYYY") : "")}`;
                return { ...item, status, weight, core_id, reel_od, finishing_date };
            });
            setMappedParentReelsList(list);
          }
          else
            setMappedParentReelsList([]);
        })
        .catch((error) => {
          setEmptyStateLabel("connectionAPIError");
          console.log("Error in search of order records:", error);
        });
    }
  };

  const refresh = () => {
    setMappedParentReelsList([]);
    setSearchValue("");
    setClearSearch(true);
    setRerendering(true);
  }

  return details && mappedParentReelsList ? (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={`${id}`}
          extra={[
            <Button
              key="2"
              disabled={
                !userDetails.roles.production.jumbo_reels.edit ||
                mappedParentReelsList.length > 0
              }
              className="themeBtn noBg grey-btn"
              onClick={deleteJumboModalShow}
            >
              <Iconmoon icon="delete" size={14} color="#A19F9D" />
              Delete Jumbo Roll
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <div className="groupedTabed">
        <StyledTab>
          <Tabs defaultActiveKey="1" onChange={handleTabChange}>
            <Panes tab="Basic Details" key="1">
              <DetailFields>
                <div className="flx-end">
                  <Button
                    key="2"
                    className="themeBtn noBg"
                    onClick={routeChange}
                    disabled={!userDetails.roles.production.jumbo_reels.edit || ((details.weight_utilized / (details.weight + details.weight_utilized)) * 100 > 0)
      }
                  >
                    <Iconmoon icon="edit" size={14} color="#EA655B" />
                    Edit Jumbo Rolls
                  </Button>
                </div>
                <HaberForm>
                  <div className="groupDetailWrap">
                    <Form
                      name="basic"
                      autoComplete="off"
                      className="haberLogin"
                    >
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={8}>
                          <GroupTitle>
                            <h2>General Details</h2>
                            <p>
                              The general details of the jumbo roll will be used
                              in reports and production details
                            </p>
                          </GroupTitle>
                        </Col>
                        <Col span={16}>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Jumbo Roll Number</label>
                                <p>
                                  Jumbo roll will be identified by this number
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="Roll Number"
                                  rules={[{ required: true }]}
                                  className=""
                                  initialValue={details.number}
                                >
                                  <Input
                                    placeholder="Enter Jumbo Roll Number"
                                    disabled
                                    defaultValue="HW19092021" // Value is populated on the basis of selection of Product Name
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={8}>
                          <GroupTitle>
                            <h2>Product Specifications</h2>
                            <p>
                              The product specification will be used to define
                              grade and quality of the jumbo roll
                            </p>
                          </GroupTitle>
                        </Col>
                        <Col span={16}>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Product Name</label>
                                <p>Unique name to identify the product</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="product name"
                                  rules={[{}]}
                                  className=""
                                >
                                  <Select
                                    placeholder="Select product name"
                                    suffixIcon={<DownArrowDraw />}
                                    defaultValue={details.product}
                                    onChange={handleProductNameChange}
                                    disabled
                                  >
                                    {productNameData.map((productName) => (
                                      <Option key={productName}>
                                        {productName}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Product Specifications</label>
                                <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="Product Spec"
                                  rules={[{}]}
                                  className=""
                                  defaultValue={details.product_spec}
                                >
                                  <Input
                                    placeholder="Product Specifications"
                                    defaultValue={details.product_spec}
                                    disabled
                                  />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={8}>
                          <GroupTitle>
                            <h2>Production Details</h2>
                            <p>
                              The production details specify when and where will
                              this jumbo roll be produced.
                            </p>
                          </GroupTitle>
                        </Col>
                        <Col span={16}>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Production Date</label>
                                <p>The production date of this jumbo roll</p>
                              </div>
                            </Col>

                            <Col span={12} className="blockBreak">
                              <div className="boxFormType">
                                <DatePickerY>
                                  <Form.Item
                                    name="Date"
                                    initialValue={moment(
                                      details.production_date,
                                      "YYYY-MM-DD"
                                    )}
                                  >
                                    <DatePicker
                                      format={"DD/MM/YYYY"}
                                      disabled
                                    />
                                  </Form.Item>
                                </DatePickerY>
                              </div>
                            </Col>
                          </Row>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Shift</label>
                                <p>Production shift for this jumbo roll </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Select
                                  placeholder="Select shift"
                                  suffixIcon={<DownArrowDraw />}
                                  defaultValue={details.shift}
                                  onChange={handleShiftChange}
                                  disabled
                                >
                                  {shiftData.map((shift) => (
                                    <Option key={shift}>{shift}</Option>
                                  ))}
                                </Select>
                              </div>
                            </Col>
                          </Row>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Weight</label>
                                <p>Weight of the jumbo roll</p>
                              </div>
                            </Col>
                            <Col span={12} className="d-flex">
                            <div
                                className="boxFormType"
                                style={{ marginBottom: "0", width: "90%", paddingRight:'5px' }}
                              >
                                <Form.Item
                                name="weight"
                                rules={[
                                  {
                                    required: true,
                                    message: "Mandatory field.",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message: "Only Numeric & Decimal Input allowed",
                                  },
                                  {
                                    max: 50,
                                    message: "Max 50 characters allowed",
                                  },
                                ]}
                                className=""
                                initialValue={details.weight + details.weight_utilized}
                              >
                                <Input placeholder="Enter Weight" disabled/>
                            </Form.Item>
                              </div>
                              <div
                          className="boxFormType"
                          style={{ marginTop: "2px", width: "90%" }}
                        >
                          <Form.Item
                          name="weightUnit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                          className=""
                          initialValue={weightUnit[details.units.weight]?.displayName}
                        >
                          <Input
                                    placeholder="Unit"
                                    disabled
                                  />
                        </Form.Item>
                        </div>
                            </Col>
                          </Row>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Machine</label>
                                <p>
                                  The Jumbo roll with be produced on selected
                                  machine
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Select
                                  placeholder="Select machine"
                                  suffixIcon={<DownArrowDraw />}
                                  defaultValue={details.machine}
                                  onChange={handleMachineChange}
                                  disabled
                                >
                                  {machineData.map((machine) => (
                                    <Option key={machine}>{machine}</Option>
                                  ))}
                                </Select>
                              </div>
                            </Col>
                          </Row>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Width</label>
                                <p>Width of the jumbo roll</p>
                              </div>
                            </Col>
                            <Col span={12} className="d-flex twoFields">
                            <div className="boxFormType" style={{ marginBottom: "0", width: "90%", paddingRight:'5px' }}>
                              <Form.Item
                                name="width"
                                rules={[
                                  {
                                    required: true,
                                    message: "Mandatory field.",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message: "Only Numeric & Decimal Input allowed",
                                  },
                                  {
                                    max: 10,
                                    message: "Max 10 digits allowed",
                                  },
                                ]}
                                className=""
                                initialValue={details.width}
                          >
                            <Input placeholder="Enter Width" disabled/>
                              </Form.Item>
                            </div>
                            <div
                            className="boxFormType"
                            style={{ marginTop: "3px", width: "90%" }}
                          >
                            <Form.Item
                              name="unit"
                              rules={[
                                {
                                  required: true,
                                  message: "This is a required field",
                                },
                              ]}
                              initialValue={lengthUnit[details.units.width]?.displayName?.toUpperCase()}
                              className="dBlock"
                            >
                              <Input placeholder="Unit" disabled/>
                            </Form.Item>
                      </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className="groupForm lastGroup">
                        <Col span={8}>
                          <GroupTitle>
                            <h2>Other Information</h2>
                            <p>
                              All other information related to this jumbo roll
                            </p>
                          </GroupTitle>
                        </Col>
                        <Col span={16}>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>
                                  Remarks <span>(Optional)</span>
                                </label>
                                <p>
                                  Extra information related to this jumbo roll
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <GlobalSet>
                                  <Form.Item
                                    name="Remarks"
                                    rules={[{ required: true }]}
                                    className=""
                                    initialValue={details.remarks ? details.remarks : ""}
                                  >
                                    <TextArea
                                      maxLength={100}
                                      style={{ height: 90 }}
                                      defaultValue={details.remarks ? details.remarks : ""}
                                      disabled
                                    />
                                  </Form.Item>
                                </GlobalSet>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </HaberForm>
              </DetailFields>
            </Panes>
            <Panes tab="Mapping Details" key="2">
              <div className="d-flex groupProd">
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Form
                        name="basic"
                        autoComplete="off"
                        className="haberLogin"
                      >
                        <Row
                          className="centerAlign"
                          style={{ marginLeft: "-10px", marginRight: "-10px" }}
                        >
                          <Col span={8} className="bl-label">
                            <div className="bl-label">
                              <label>Total Jumbo Roll Weight</label>
                            </div>
                            <div className="boxFormType">
                              <Form.Item
                                name="Roll Weight"
                                rules={[{ required: true }]}
                                className=""
                              >
                                <Input
                                  placeholder=""
                                  disabled
                                  defaultValue={(
                                    details.converted_weight + details.converted_weight_utilized
                                  ).toFixed(3)}
                                />
                              </Form.Item>
                              <span className="nonEditable">{capitalize(weightUnit[measurementData?.units_management?.weight?.default]?.displayName)}</span>
                            </div>
                          </Col>
                          <Col span={8} className="bl-label">
                            <div className="bl-label">
                              <label>Utilized Jumbo Roll Weight</label>
                            </div>
                            <div className="boxFormType">
                              <Form.Item
                                name="Roll Weight"
                                rules={[{ required: true }]}
                                className=""
                              >
                                <Input
                                  placeholder=""
                                  disabled
                                  defaultValue={details?.converted_weight_utilized?.toFixed(
                                    2
                                  )}
                                />
                              </Form.Item>
                              <span className="nonEditable">{capitalize(weightUnit[measurementData?.units_management.weight.default].displayName)}</span>                            </div>
                          </Col>
                          <Col span={8} className="bl-label">
                            <div className="bl-label">
                              <label>Remaining Jumbo Roll Weight</label>
                            </div>
                            <div className="boxFormType">
                              <Form.Item
                                name="Roll Weight"
                                rules={[{ required: true }]}
                                className=""
                              >
                                <Input
                                  placeholder=""
                                  disabled
                                  defaultValue={details?.converted_weight?.toFixed(3)}
                                />
                              </Form.Item>
                              <span className="nonEditable">{capitalize(weightUnit[measurementData?.units_management.weight.default].displayName)}</span>                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </HaberForm>
                </DetailFields>
              </div>
              <TableLayoutData>
                <div className="tableDataFormat">
                  <SearchContainer
                    placeholder={"Search parent reel number or job card number"}
                    fetchOrder={searchJumboRollMappingDetails}
                    exportRole={userDetails.roles.production.jumbo_reels.view}
                    exportTrigger={exportHandler}
                    clearSearch={clearSearch}
                    setClearSearch={setClearSearch}
                    searchedValue={searchValue}
                    closeMappingRole={userDetails.roles.production.jumbo_reels.edit}
                    closeMapping={showCloseModal}
                    jumboStatus = {details.status}
                    jumboReelSearch={true}
                  />
                  {(mappedParentReelsList && mappedParentReelsList.length) ? (
                  <Table
                    columns={columnsHead}
                    dataSource={mappedParentReelsList}
                    scroll={{ x: window.screen.width < 1500 && 1420 }}
                    onChange={onChange}
                    pagination={{
                      total: mappedParentReelsList.length,
                      showTitle: false,
                      showTotal: (total, range) =>
                        `Showing ${range[0]}-${range[1]} of ${total} results`,
                    }}
                  />) : (
                    <EmptyState
                      img={emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData :
                      emptyStateLabel === "search" ? emptyState_Search :
                      emptyState_ConnectionAPIError}
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </div>
              </TableLayoutData>
            </Panes>
          </Tabs>
        </StyledTab>
      </div>

      {/* <ParentJumboReelDrawer
        visible={viewParentJumboReelDrawer}
        selectedJR={selectedJR}
        onCloseJumboReel={closeParentJumboReel}
      ></ParentJumboReelDrawer> */}

        {/* {viewParentJumboReelDrawer && (
          <MultiStageParentSetDrawer
            parentReelId={selectedJR}
            visible={viewParentJumboReelDrawer}
            onClose={closeParentJumboReel}
            isProduced={isProduced}
            jobcardType={jobcardType}
            page={"jumbo records"}
          />
        )} */}

      {viewParentJumboReelDrawer && (<JumboReelParentSetDrawer
           parentReelId={selectedJR}
            visible={viewParentJumboReelDrawer}
            onClose={closeParentJumboReel}
            isProduced={isProduced}
            jobcardType={jobcardType}
            page={"jumbo records"}>
      </JumboReelParentSetDrawer>)}


      {/* For Delete Jumbo Reel Modal Popup  */}
      <ModalPopup visible={isVisibleDeleteJumboModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Jumbo Roll?</span>
          <p>
            The jumbo will be deleted and cannot be recovered. Are you sure you
            want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => deleteJumboModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteReel(id)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      {/* For Close Jumbo Reel Modal Popup  */}
      <ModalPopup visible={isVisibleJumboModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Close Jumbo</span>
          <p>
            This jumbo will not be available for any other mappings. Are you
            sure you want to continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => jumboModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button className="themeBtn">
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      {showToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setShowToaster}
          color={actionToaster.error ? "red toaster" : "green toaster"}
          icon={actionToaster.error ? alertRed : alertGreen}
          msg={actionToaster.msg}
        >
          {setTimeout(() => {
            setShowToaster(false);
            history("../jumbo-reel-records");
          }, 3000)}
        </AlertContainer>
      )}

      <ConfirmationModal
        visible={closeJumboVisible}
        icon={warning}
        cancelAction={cancelCloseModal}
        confirmAction={confirmCloseModal}
      >
        <span>Close Jumbo?</span>
        <p>
          This jumbo will not be available for any other mappings. Are you sure
          you want to continue?
        </p>
      </ConfirmationModal>
    </RightLayoutContainer>
  ) : (
    <></>
  );
};

export default ViewJumboReel;
